import { Button } from "@mui/material";
import { QUERY_KEYS } from "constant/react_query";
import { useSeriesPhotosUpdate } from "hooks/citajteo/photo_series/useSeriesPhotosUpdate";
import { PhotoInfo } from "model/photo_series/PhotoInfo";
import toast from "react-hot-toast";
import styled from "styled-components";

type SeriesPhotoFileNamesProps = {
  photoSerId: string;
  fileNames: PhotoInfo[];
  setFileNames: React.Dispatch<React.SetStateAction<PhotoInfo[]>>;
  resetFileNames: () => void;
};

const SeriesPhotoFileNames = ({
  photoSerId,
  fileNames,
  setFileNames,
  resetFileNames,
}: SeriesPhotoFileNamesProps) => {
  const { seriesPhotosUpdateMutate } = useSeriesPhotosUpdate({
    invalidateKeys: [
      QUERY_KEYS.CITAJTEO_PHOTO_SERIES_SEARCH,
      QUERY_KEYS.CITAJTEO_PHOTO_SERIES_GET,
    ],
  });

  if (!photoSerId) {
    return null;
  }

  const seriesPhotoFileNamesUpdate = () => {
    seriesPhotosUpdateMutate(
      { photoSerId, photos: fileNames },
      {
        onSuccess: (data: any) => {
          console.log(data.msg);
          toast.success("Uspešno ažuriranje fotografija serije.");
        },
        onError: (error) => {
          console.error("Error adding units:", error);
          toast.error("Greška pri unosu fotografija serije.");
        },
      },
    );
  };

  return (
    <DivNav>
      <Button type="button" onClick={seriesPhotoFileNamesUpdate}>
        OK
      </Button>
      <Button onClick={resetFileNames} type="button">
        Cancel
      </Button>
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 2rem;
  display: flex;
  gap: 0.75rem;
`;

export default SeriesPhotoFileNames;
